var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tenantApiKey)?_c('div',[_c('tenant-members',{attrs:{"title":_vm.tenantName + ' ' + _vm.$t('models.user.plural').toString().toLowerCase(),"propTenantApiKey":_vm.tenantApiKey}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }